import { useEffect, useRef } from 'react';
import { useOptionalFocusedField } from '../contexts/focused-field-provider';
import { useOptionalScroll } from '../contexts/scroll-provider';
// Scrolls the field's own cell into view when the field is focused, e.g. on a
// validation error or a step change. Does nothing outside the providers.
export const useScrollWhenFocused = (fieldId)=>{
    const ref = useRef(null);
    const scrollTo = useOptionalScroll()?.scrollTo;
    const focusedFieldId = useOptionalFocusedField()?.focusedFieldId;
    useEffect(()=>{
        if (scrollTo && ref.current && fieldId === focusedFieldId) {
            scrollTo(ref.current);
        }
    }, [
        scrollTo,
        fieldId,
        focusedFieldId
    ]);
    return ref;
};

//# sourceMappingURL=use-scroll-when-focused.js.map